import {
  Stack,
  Avatar,
  Box,
  Typography,
  useTheme
} from '@mui/material';
import React from 'react';



export type LogEventProps = {
  id: string;
  description: string;
  personName: string;
  createdAt: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: LogEventProps) => {
  const theme = useTheme();
  return (
    <Stack
      direction='column'
    >
      <Stack
        direction='row'
        columnGap='.625rem'
      >
        <Avatar
          sizes='medium'
        />
        <Box>
          <Box >
            <Typography
              variant='taskTitle'
              color={theme.palette.primary.main}
            >
              {props.personName}
            </Typography>
          </Box>
          <Box
            paddingBottom='0rem'
          >
            <Typography variant='taskSubtitle'>
              Added on {props.createdAt}
            </Typography>
          </Box>
        </Box>
      </Stack>

      <Box
        marginLeft='1.25rem'
        paddingLeft='1.8rem'
        borderLeft={`1px solid ${theme.palette.secondary.dark}`}
      >
        <Typography
          variant='formInput'
        >
          {props.description}
        </Typography>
      </Box>
    </Stack>
  );
};
